import { Maintenance } from 'sections';
import { ToastContainer } from 'react-toastify';
import { Head } from 'head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Basic as Layout} from 'layout';

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      // Will be passed to the page component as props
    },
  };
}

const Home = () => (
  <>
    <Head title='Nadine Pesso | Frontend Developer Portfolio' />
    <ToastContainer
      hideProgressBar
      pauseOnHover
    />
    <Layout>
      <Maintenance />
    </Layout>
  </>
);

export default Home;
